import { GlobalService } from './global.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { daApi, MAP_USUARIO } from './api-map';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  redirectUrl = '';
  isRecuperarSenha: boolean = false;
  token: string;
  user: any;

  constructor(
    public http: HttpClient,
    public global: GlobalService
  ) { }

  // A API nova responde { auth, token, refreshToken, message } sempre com status 200:
  // quem diz se entrou ou nao e o campo `auth`.
  login(user) {
    return this.http.post(this.global.apiUrl + '/auth/sign-in', {
      user: user.email,
      password: user.senha,
      typeAuth: 'web'
    });
  }

  getAuthorizationHeader() {
    return new HttpHeaders().append('x-access-token', this.token || '');
  }

  getUserStorage() {
    return JSON.parse(localStorage.getItem('user_culturao'));
  }

  setToken(token) {
    if (!token) {
      return;
    }

    this.token = token;
    localStorage.setItem('token_culturao', this.token);
  }

  setUser(user) {
    if (!user) {
      return;
    }

    localStorage.setItem('user_culturao', JSON.stringify(user));
    this.user = this.getUserStorage();
  }

  getUser(user) {
    return new Promise((resolve, reject) => {
      this.http.get(this.global.apiUrl + `/user?page=1&count=1&filter=${encodeURIComponent(user.email)}`)
        .pipe(map((res: any) => (res && res.data && res.data[0]) ? daApi(res.data[0], MAP_USUARIO) : null))
        .subscribe((res: any) => {
          resolve(res);
        }, (e) => {
          reject(e);
        });
    })
  }

  logout() {
    this.token = undefined;
    this.user = null;
    localStorage.clear();
  }

  isLoggedIn() {
    if (!this.token) {
      if (localStorage.getItem('token_culturao')) {
        this.setToken(localStorage.getItem('token_culturao'));
        this.user = this.getUserStorage();
      } else {
        return false;
      }
    }

    return true;
  }

  // Dispara o e-mail com o codigo de verificacao usado na troca de senha.
  forgotPassword(user) {
    return new Promise((resolve, reject) => {
      this.http.post(this.global.apiUrl + '/auth/create', { user: user.email })
        .subscribe((res: any) => {
          resolve(res);
        }, (e) => {
          reject(e);
        });
    })
  }

  // Troca a senha usando o codigo recebido por e-mail.
  updatePassword(email: string, password: string, key: string) {
    return new Promise((resolve, reject) => {
      this.http.post(this.global.apiUrl + '/auth/update-password', { email, password, key })
        .subscribe((res: any) => {
          resolve(res);
        }, (e) => {
          reject(e);
        });
    })
  }
}
